var render = function render(){var _vm=this,_c=_vm._self._c;return _c('issue-probability',{staticClass:"issue-probability",attrs:{"issue":_vm.item,"isTranslation":_vm.isTranslation}})
}
var staticRenderFns = []

export { render, staticRenderFns }